import { api } from '../api'

export const categoryAccessPolicyApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCategoryAccessPolicies: builder.query({
      query: (companyId) => ({
        url: `/category-access-policies/${companyId}`,
      }),
      providesTags: ['CategoryAccessPolicies'],
    }),
    createCategoryAccessPolicy: builder.mutation({
      query: ({ companyId, policy }) => ({
        url: `/category-access-policies/${companyId}`,
        method: 'POST',
        body: policy,
      }),
      invalidatesTags: ['CategoryAccessPolicies'],
    }),
    updateCategoryAccessPolicy: builder.mutation({
      query: ({ policyId, policy }) => ({
        url: `/category-access-policies/policy/${policyId}`,
        method: 'PUT',
        body: policy,
      }),
      invalidatesTags: ['CategoryAccessPolicies'],
    }),
    deleteCategoryAccessPolicy: builder.mutation({
      query: (policyId) => ({
        url: `/category-access-policies/policy/${policyId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['CategoryAccessPolicies'],
    }),
    getPolicyAssignments: builder.query({
      query: (companyId) => ({
        url: `/category-access-policies/${companyId}/assignments`,
      }),
      providesTags: ['CategoryAccessPolicies'],
    }),
    assignPolicyToUser: builder.mutation({
      query: ({ companyId, userId, policyId }) => ({
        url: `/category-access-policies/${companyId}/assignments/${userId}`,
        method: 'PUT',
        body: { policyId },
      }),
      invalidatesTags: ['CategoryAccessPolicies'],
    }),
    getAllowedCategories: builder.query({
      query: (companyId) => ({
        url: `/category-access-policies/${companyId}/allowed-categories`,
      }),
      providesTags: ['CategoryAccessPolicies', 'Categories'],
    }),
  }),
})

export const {
  useGetCategoryAccessPoliciesQuery,
  useCreateCategoryAccessPolicyMutation,
  useUpdateCategoryAccessPolicyMutation,
  useDeleteCategoryAccessPolicyMutation,
  useGetPolicyAssignmentsQuery,
  useAssignPolicyToUserMutation,
  useGetAllowedCategoriesQuery,
} = categoryAccessPolicyApi
